import React from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Shared configuration
import { appTheme } from "@/shared/config/theme";

// Shared components
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";
import ProgressBar from "@/shared/components/ProgressBar";

// Auth Context
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <ProgressBar />
        <AuthProvider>
          <Outlet />
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
